export default "__VITE_ASSET__BDiouObm__"